<template>
  <div>
    <ButtonBase color="builders" :style-type="isText ? 'base' : 'round'" :size="size" :to="{ query: { ...(route.query ?? {}), complete: true } }" v-if="!currentUser?.isOnboarded2">
      <IconBase name="cute/user-add-fill" :width="18" />
      <span class="ml-1" v-if="isText">{{ $t('actions.follow') }}</span>
    </ButtonBase>
    <ButtonBase color="xweak" :style-type="'round'" :size="size" @click.prevent.stop="onUnfollow" v-else-if="following.includes(user._id)">
      <IconBase name="cute/user-follow-fill" :width="18" />
      <!-- <span class="ml-1" v-if="isText">{{ $t('actions.unfollow') }}</span> -->
    </ButtonBase>
    <ButtonBase color="builders" :style-type="isText ? 'base' : 'round'" :size="size" @click.prevent.stop="onFollow" v-else>
      <IconBase name="cute/user-add-fill" :width="18" :class="[ isText ? 'ml-0.5' : '']" />
      <span class="mx-1" v-if="isText">{{ $t('actions.follow') }}</span>
    </ButtonBase>
  </div>
</template>

<script lang="ts" setup>
import { User } from '@/classes'
import UserStore from '@/store/user'
import WindowStore from '@/store/window'
import SentimentsStore from '@/store/sentiments'

const props = withDefaults(defineProps<{
  user: User
  size?: 'base' | 'sm' | 'xs' | '2xs'
  isConfirm?: boolean
  isText?: boolean
}>(), {
  isTheme: true,
  isConfirm: false,
  isText: false,
  size: 'base'
})

const { user } = toRefs(props)

const sentimentsStore = SentimentsStore()
const userStore = UserStore()
const windowStore = WindowStore()
const { currentUser, following, followers } = storeToRefs(userStore)

const route = useRoute()

const isLoading = ref(false)

const onUnfollow = async () => {  
  windowStore.setAlert({
    title: useNuxtApp().$i18n.t('components.User.follow.stop', { name: user.value.name }),
    actions: [
      {
        text: useNuxtApp().$i18n.t('actions.cancel'),
        button: { color: 'xweak' },
        isCloseAction: true,
        action: () => {

        }
      },
      {
        text: useNuxtApp().$i18n.t('actions.unfollow'),
        button: { color: 'white' },
        isMainAction: true,
        action: async () => {
          await sentimentsStore.follow(user.value)
        }
      }
    ]
  })
}

const onFollow = async () => {
  isLoading.value = true
  
  await sentimentsStore.follow(user.value)

  isLoading.value = false
}
</script>